var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "fc-notice ask" }, [
    _c("img", {
      staticClass: "fc-icon-sm",
      attrs: { src: require("../assets/img/question_icon.png") }
    }),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "fc-color-gray",
        attrs: {
          href: _vm.getH5Url() + "/recharge_faq/index.html",
          target: "_blank"
        }
      },
      [_vm._v(_vm._s(_vm.$t("m.rechargeFAQ_title")))]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70e22419", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70e22419","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href","audio":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ask.vue
// module id = null
// module chunks = 